import React from 'react'
import { Confirm } from '../../application'
import getText from '../strings'
import styled from 'react-emotion'
import { colors } from "../../styles"

const Wrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
`
const Button = styled("div")`
  display: flex;
  align-items: center;
  line-height: 1em;
  background-color: ${colors.tui_beige_25};
  border-radius: 4px;
  padding: 10px;
  margin-right: 20px;
  cursor: pointer;
  .pictogram {
    margin-right: 5px;
  }
  @media (max-width: 767px) {
    justify-content: center;
    padding: 10px 0;
    margin-right: 0px;
    margin-top: 5px;
  }
  svg {
    color: ${colors.tui_green};
    height: 18px;
  }
`
export default ({ bookingNumber,sourceSystem, cancelBooking }) => (
  <Wrapper>
    <Confirm
      question={getText('selfservice', 'cancelHotel', 'question')}
      onResult={res => res && cancelBooking(bookingNumber, sourceSystem)}
      Opener={() =>
        <Button>
            <strong>{getText('selfservice', 'cancelHotel', 'button')}</strong>
        </Button>
      } />
  </Wrapper>
)